import React from "react";
import Layout from "../components/Layout";
import { graphql, Link } from "gatsby";
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const CategoryTemplate = ({ data, pageContext }) => {
  const {
    allMdx: { nodes: posts },
  } = data;
  const { category } = pageContext;
  return (
    <Layout>
      <header className="projects-hero">
        <div className="section-title">
          <h1>{`category / ${category}`}</h1>
          <div className="underline"></div>
        </div>
      </header>
      <section className="section blog">
        <div className="section-center blog-center">
          {posts.map((post, index) => {
            const { frontmatter, excerpt, timeToRead } = post;
            const { title, image, slug, date } = frontmatter;
            return (
              <div key={index} className="card">
                <div className="card-side card-front">
                  <GatsbyImage image={getImage(image)} alt={slug} />
                  <div className="card-info">
                    <h4>{title}</h4>
                    <p>{excerpt}</p>
                    <div className="card-footer">
                      <p>{date}</p>
                      <p>{timeToRead} min read</p>
                    </div>
                  </div>
                </div>

                <div className="card-side card-back">
                  <Link to={`/posts/${slug}`} className="btn">
                    read more
                  </Link>
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </Layout>
  );
};

export const query = graphql`
  query GetCategories($category: String) {
    allMdx(
      sort: { fields: frontmatter___date, order: DESC }
      filter: { frontmatter: { category: { eq: $category } } }
    ) {
      nodes {
        id
        frontmatter {
          title
          author
          category
          slug
          date(formatString: "MMMM, Do YYYY")
          image {
            childImageSharp {
              gatsbyImageData(placeholder: TRACED_SVG, layout: FULL_WIDTH)
            }
          }
        }
        timeToRead
        excerpt
      }
    }
  }
`;

export default CategoryTemplate;
